import type { Dispatch } from "redux";
import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export function dispatchError(error: any) {
	if (error.type === server.READING_MODE_ERROR) {
		return (dispatch: Dispatch) => {
			dispatch(actions.readingModeError());
		};
	}
	if (error.type === server.RPM_ACCESS_ERROR) {
		return (dispatch: Dispatch) => {
			dispatch(actions.rpmAccessError());
		};
	}
	return (dispatch: Dispatch) => {
		dispatch(
			actions.error({
				error,
				message: String(error),
				stack: error.stack,
			}),
		);
	};
}

export function dispatchReadingModeError() {
	return (dispatch: Dispatch) => dispatch(actions.readingModeError());
}

export function clearError() {
	return (dispatch: Dispatch) => dispatch(actions.clearError());
}

export function serverValidationError(errors: any) {
	return (dispatch: Dispatch) => dispatch(actions.serverValidationError(errors));
}

export function clearValidationError(field: any) {
	return (dispatch: Dispatch) => dispatch(actions.clearValidationError(field));
}

export function validateEmail(email: string) {
	return (dispatch: Dispatch) =>
		server
			.validateEmail(email)
			.then(() => true)
			.catch((e) => {
				if (e.type === server.SERVER_VALIDATION_ERROR) {
					dispatch(
						actions.serverValidationError({
							message: e.message,
							cause: actions.VALIDATE_EMAIL,
						}),
					);
					return false;
				}
				throw e;
			});
}
